import { render, staticRenderFns } from "./ArchivedReport.vue?vue&type=template&id=4dbee1a5&"
import script from "./ArchivedReport.vue?vue&type=script&lang=js&"
export * from "./ArchivedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports